<script setup lang="ts">
defineProps({
  href: {
    type: String,
    default: ''
  },
  blank: {
    type: Boolean,
    default: false
  }
})
</script>

<template>
  <NuxtLink :href="href" target="_blank" class="underline font-bold hover:no-underline">
    <slot />
  </NuxtLink>
</template>
